import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { getCurrentUserId, getAccessToken } from "../awsAuth";
import axios from "axios";

const AuthContext = createContext();

const sendHeartbeat = async (userId) => {
  try {
    const token = await getAccessToken();
    if (!token || !userId) return;

    await axios.post(
      `/api/account/heartbeat/${userId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (e) {
    // тихо ігноруємо
  }
};

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedInState] = useState(false);
  const [userId, setUserId] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshAuth = useCallback(async (options = {}) => {
  const { silent = false } = options;

  if (!silent) {
    setLoading(true);
  }

  try {
    const token = await getAccessToken?.().catch(() => null);
    const id = getCurrentUserId?.() || null;

    const logged = !!token && !!id;

    setIsLoggedInState(logged);
    setUserId(logged ? id : null);
  } catch {
    setIsLoggedInState(false);
    setUserId(null);
  } finally {
    if (!silent) {
      setLoading(false);
    }
  }
}, []);

  useEffect(() => {
    refreshAuth();
  }, [refreshAuth]);

  useEffect(() => {
  if (!isLoggedIn || !userId) return;

  sendHeartbeat(userId);

  const interval = setInterval(() => {
    sendHeartbeat(userId);
  }, 5 * 60 * 1000);

  return () => clearInterval(interval);
}, [isLoggedIn, userId]);

  useEffect(() => {
  const onStorage = () => {
    refreshAuth({ silent: true });
  };

  const onFocus = () => {
    refreshAuth({ silent: true });
  };

  window.addEventListener("storage", onStorage);
  window.addEventListener("focus", onFocus);

  return () => {
    window.removeEventListener("storage", onStorage);
    window.removeEventListener("focus", onFocus);
  };
}, [refreshAuth]);

  const setIsLoggedIn = useCallback(
    async (next) => {
      if (!next) {
        setLoading(false);
        setIsLoggedInState(false);
        setUserId(null);
        return;
      }

      await refreshAuth();
    },
    [refreshAuth]
  );

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        userId,
        loading,
        refreshAuth,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);